/** The next session's standard look (signed-in-home.html Band 4, the accent pass): View booking is the only filled button. */
import { partsOf, pieceRoot, usePlaced } from '../../contract/runtime';
import account from '../../styles/account.module.css';
import shared from '../../styles/shared.module.css';
import { Icon } from '../../ui/Icon';
import { onLink } from '../../ui/onLink';
import { Photo } from '../../ui/Photo';
import css from './NextSession.module.css';
import type { NextSessionRuntime } from './useNextSession';
import { contract } from './contract';

const part = partsOf(contract);

export function NextSessionView({ state, actions, options }: NextSessionRuntime) {
  // Placed on a custom page (web-studio-sites D4): no outer margin.
  const placed = usePlaced();
  const b = state.booking;
  if (!b) return null;
  const session = (
    <div className={`${css.next} ${placed && !options.heading ? css.placed : ''}`} {...(options.heading ? {} : pieceRoot(contract))} {...part('session')}>
      <div className={css.main} {...part('main')}>
        {/* With no picture at all the spot is left out, never drawn empty (web-account-pages D13). */}
        {b.photo && (
          <div className={css.photo} {...part('photo')}>
            <Photo photo={b.photo} />
          </div>
        )}
        <div {...part('details')}>
          <h2 className={css.name} {...part('name')}>
            {b.name}
            <span className={css.status} {...part('status')}>
              {b.status}
            </span>
          </h2>
          <p className={css.line} {...part('when')}>
            <span className={css.when}>{b.when}</span>
            {b.length}
          </p>
          {b.where && (
            <p className={css.line} {...part('where')}>
              {b.where}
            </p>
          )}
        </div>
      </div>
      <div className={css.ctas}>
        <a className={`${shared.btn} ${shared.btnPrimary}`} href={b.href} onClick={onLink(() => actions.open(b.href))} {...part('viewBooking')}>
          View booking
          <Icon name="arrow" />
        </a>
        {b.joinHref ? (
          <a className={`${shared.btn} ${shared.btnOutline}`} href={b.joinHref} target="_blank" rel="noopener noreferrer" {...part('join')}>
            Join session
          </a>
        ) : b.directionsHref ? (
          <a className={`${shared.btn} ${shared.btnOutline}`} href={b.directionsHref} target="_blank" rel="noopener noreferrer" {...part('directions')}>
            Directions
          </a>
        ) : null}
      </div>
    </div>
  );
  // web-studio-sites D12: the standard home sets no heading (its welcome line says it); a custom site's Bookings page does.
  if (!options.heading) return session;
  return (
    <section className={`${account.sec} ${css.section}`} aria-label={options.heading} {...pieceRoot(contract)}>
      <div className={`${account.label} ${css.head}`}>
        <h2 className={`${account.eyebrow} ${css.heading}`} {...part('heading')}>
          {options.heading}
        </h2>
      </div>
      {session}
    </section>
  );
}
